import { useCallback, useEffect, useRef, useState } from "react"

export function useScrollAreaHeight() {
  const [tableTop, setTableTop] = useState(0)
  const containerRef = useRef<HTMLDivElement>(null)

  const recalculateTableTop = useCallback(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect()
      setTableTop(rect.top)
    }
  }, [])

  useEffect(() => {
    recalculateTableTop()

    // Use ResizeObserver to detect layout changes
    const resizeObserver = new ResizeObserver(() => {
      recalculateTableTop()
    })

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    window.addEventListener("resize", recalculateTableTop)
    window.addEventListener("scroll", recalculateTableTop)

    return () => {
      resizeObserver.disconnect()
      window.removeEventListener("resize", recalculateTableTop)
      window.removeEventListener("scroll", recalculateTableTop)
    }
  }, [recalculateTableTop])

  return { tableTop, containerRef, recalculateTableTop }
}
